import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useVideoPlayerStore from '../../store';

export const useLanguageSettings = playerTalkData => {
  const router = useRouter();
  const { onLanguages, onNativeLanguage, requestSubtitleLanguage } =
    useVideoPlayerStore(state => ({
      onLanguages: state.onLanguages,
      onNativeLanguage: state.onNativeLanguage,
      requestSubtitleLanguage: state.requestSubtitleLanguage
    }));

  useEffect(() => {
    if (playerTalkData) {
      const currentLanguage = playerTalkData.languages.find(
        lang => lang.languageCode === router.query?.lang
      );

      onLanguages(playerTalkData?.languages);
      onNativeLanguage(playerTalkData?.nativeLanguage);

      if (currentLanguage && currentLanguage.languageCode) {
        requestSubtitleLanguage(currentLanguage.languageCode);
      }
    }
  }, [
    onLanguages,
    onNativeLanguage,
    playerTalkData,
    requestSubtitleLanguage,
    router.query?.lang
  ]);
};
